<template>
  <div class="section col_w_3">
    <div class="section_wrap">
      <h6 class="--blue70 mb20">{{ $t('account.change_password') }}</h6>
      <p class="option_desc">{{ $t('account.password_form') }}</p>
      <ChangePwForm ref="changePwFormRef"/>
      <ChangePwButton @changePassword="changePassword"/>
    </div>
  </div>
</template>
<script>
import ChangePwForm from "./changePwForm";
import ChangePwButton from "./changePwButton";

export default {
  components: {
    ChangePwForm,
    ChangePwButton
  },
  methods: {
    changePassword() {
      this.$refs.changePwFormRef.changePassword();
    }
  }
}
</script>
